/* ========================================================================= */
/* Scale to new range */
/* ========================================================================= */

/**
 * @function linearScale
 * @param {number} value - original range current value
 * @param {number} min - original range minimum value
 * @param {number} max - original range maximum value
 * @param {number} newMin - new range minimum value
 * @param {number} newMax - new range maximum value
 * @return {number} - new range value
 *
 * Scale value from original range to new value in new range in a linear way
 */
export const linearScale = (val, min, max, newMin, newMax) => {
    // https://stackoverflow.com/a/5295202
    let newValue = (((newMax - newMin) * (val - min)) / (max - min)) + newMin;

    if (newValue < newMin) {
        newValue = newMin;
    }

    if (newValue > newMax) {
        newValue = newMax;
    }

    return newValue;
};
